module.exports = __webpack_public_path__ + "static/img/council.0c2a16d.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/council.png
// module id = n6zA
// module chunks = 1